import { axios } from '@/utils/request'

const api = {
  // 报警记录管理
  alarmPage: '/alarm/page',
  alarmDelete: '/alarm/delete',
  alarmSave: '/alarm/save',
  alarmUpdate: '/alarm/update',
  // 日志记录管理
  logPage: '/log/page',
  // 附件管理
  attachmentPage: '/attachment/page',
  attachmentDeleteFileById: '/attachment/deleteFileById',
  attachmentDownFile: '/attachment/downFile',
  attachmentUpload: '/attachment/upload',
  // 字典管理
  codeList: '/code/list',
  codePage: '/code/page',
  codeDelete: '/code/delete',
  codeSave: '/code/save',
  codeUpdate: '/code/update',
  getNameByTypeAndValue: '/code/getNameByTypeAndValue',
  getBusinessTypeNodeInfo: '/code/getBusinessTypeNodeInfo',
  // 字典类型管理
  codeTypeList: '/codeType/list',
  codeTypePage: '/codeType/page',
  codeTypeDelete: '/codeType/delete',
  codeTypeSave: '/codeType/save',
  codeTypeUpdate: '/codeType/update',
  // 菜单管理
  menuList: '/Menu/list',
  menuPage: '/Menu/page',
  menuDelete: '/Menu/delete',
  menuSave: '/Menu/save',
  menuUpdate: '/Menu/update',
  menuTree: '/Menu/tree',
  // 权限管理
  findPrivileBycode: '/privilege/findPrivileBycode',
  privilegePage: '/privilege/page',
  privilegeDelete: '/privilege/delete',
  privilegeSave: '/privilege/save',
  privilegeUpdate: '/privilege/update',
  privilegeTree: '/privilege/findTree',
  privilegefindPrivilegeByRole: '/privilege/findPrivilegeByRole',
  wxButtonTree: '/wxButton/findTree',
  findWeiXinPrivilegeByRole: '/wxButton/findWxButtonByRoleId',
  roleSetWxButton: '/wxButton/setWxPrivillege',

  // 角色管理
  rolePage: '/role/page',
  roleList: '/role/list',
  roleDelete: '/role/delete',
  roleSave: '/role/save',
  roleUpdate: '/role/update',
  roleSetProvollege: '/role/setPrivillege',

  // 微信按钮管理
  wxButtonList: '/wxButton/list',

  //用于供应商增加的业务员查询
  userList: '/user/list',

  // 检查用户名是否存在
  userCheckUserNameIsExist: '/user/checkUsernameIsExist ',
  //  获取当前登录用户信息
  userInfo: '/user/info',
  //  删除用户
  userDelete: '/user/delete ',
  //  用户分页查询
  userPage: '/user/page ',
  //   添加或修改用户
  userSave: '/user/save ',

  userOnlinePage: '/userOnline/page',
  userOnlineList: '/userOnline/list',
  userOnlineDelete: '/userOnline/delete',
  userOnlineSave: '/userOnline/save',
  userOnlineUpdate: '/userOnline/update',
  userOnlineOffLine: '/userOnline/offLine',

  // 导出用户
  userExport: '/user/createUserExcel',
  //  重置密码
  userResetPassWord: '/user/resetPassword ',

  //  修改密码
  userModifyPassword: '/user/modifyPassword ',
  // 字段列表
  columnsList: '/columns/list ',

  // 终端管理
  terminalPage: '/terminal/page',
  terminalDelete: '/terminal/delete',
  terminalSave: '/terminal/save',
  terminalUpdate: '/terminal/update',
  terminalAccredit: '/terminal/accredit',



  // 按钮管理
  buttonPage: '/wxButton/page',
  buttonDelete: '/wxButton/deleteWxButton',
  buttonSave: '/wxButton/saveWxButton',
  buttonUpdate: '/wxButton/saveWxButton',

  settingsList: '/settings/list',
  settingsDelete: '/settings/delete',
  settingsSave: '/settings/save',
  settingsUpdate: '/settings/update',
  settingUpdateBatch: '/settings/updateBatch',
  findproperties: '/settings/findproperties',
  getwxcode: '/user/infocode',
  getopenid: '/WXBangDing/getOpenId'
}

export default api

export function alarmPage(parameter) {
  return axios({
    url: api.alarmPage,
    method: 'post',
    data: parameter
  })
}
export function alarmDelete(parameter) {
  return axios({
    url: api.alarmDelete,
    method: 'get',
    params: parameter
  })
}
export function alarmSave(parameter) {
  return axios({
    url: api.alarmSave,
    method: 'post',
    data: parameter
  })
}
export function alarmUpdate(parameter) {
  return axios({
    url: api.alarmUpdate,
    method: 'post',
    data: parameter
  })
}

export function logPage(parameter) {
  return axios({
    url: api.logPage,
    method: 'post',
    data: parameter
  })
}

export function attachmentPage(parameter) {
  return axios({
    url: api.attachmentPage,
    method: 'post',
    data: parameter
  })
}
export function attachmentDeleteFileById(parameter) {
  return axios({
    url: api.attachmentDeleteFileById,
    method: 'get',
    params: parameter
  })
}
export function attachmentDownFile(parameter) {
  return axios({
    url: api.attachmentDownFile,
    method: 'get',
    params: parameter
  })
}
export function attachmentUpload(parameter) {
  return axios({
    url: api.attachmentUpload,
    method: 'post',
    data: parameter
  })
}

export function codeList(parameter) {
  return axios({
    url: api.codeList,
    method: 'get',
    params: parameter
  })
}
export function codePage(parameter) {
  return axios({
    url: api.codePage,
    method: 'get',
    params: parameter
  })
}
export function codeDelete(parameter) {
  return axios({
    url: api.codeDelete,
    method: 'get',
    params: parameter
  })
}
export function codeSave(parameter) {
  return axios({
    url: api.codeSave,
    method: 'post',
    data: parameter
  })
}
export function codeUpdate(parameter) {
  return axios({
    url: api.codeUpdate,
    method: 'post',
    data: parameter
  })
}
export function getNameByTypeAndValue(parameter) {
  return axios({
    url: api.getNameByTypeAndValue,
    method: 'get',
    params: parameter
  })
}
export function getBusinessTypeNodeInfo(parameter) {
  return axios({
    url: api.getBusinessTypeNodeInfo,
    method: 'get',
    params: parameter
  })
}

export function codeTypeList(parameter) {
  return axios({
    url: api.codeTypeList,
    method: 'get',
    params: parameter
  })
}
export function codeTypePage(parameter) {
  return axios({
    url: api.codeTypePage,
    method: 'get',
    params: parameter
  })
}
export function codeTypeDelete(parameter) {
  return axios({
    url: api.codeTypeDelete,
    method: 'get',
    params: parameter
  })
}
export function codeTypeSave(parameter) {
  return axios({
    url: api.codeTypeSave,
    method: 'post',
    data: parameter
  })
}
export function codeTypeUpdate(parameter) {
  return axios({
    url: api.codeTypeUpdate,
    method: 'post',
    data: parameter
  })
}

export function menuList(parameter) {
  return axios({
    url: api.menuList,
    method: 'get',
    params: parameter
  })
}
export function menuPage(parameter) {
  return axios({
    url: api.menuPage,
    method: 'get',
    params: parameter
  })
}
export function menuDelete(parameter) {
  return axios({
    url: api.menuDelete,
    method: 'get',
    params: parameter
  })
}
export function menuSave(parameter) {
  return axios({
    url: api.menuSave,
    method: 'post',
    data: parameter
  })
}
export function menuUpdate(parameter) {
  return axios({
    url: api.menuUpdate,
    method: 'post',
    data: parameter
  })
}
export function menuTree(parameter) {
  return axios({
    url: api.menuTree,
    method: 'get',
    params: parameter
  })
}

export function privilegePage(parameter) {
  return axios({
    url: api.privilegePage,
    method: 'get',
    params: parameter
  })
}
export function findPrivileBycode(parameter) {
  return axios({
    url: api.findPrivileBycode,
    method: 'get',
    params: parameter
  })
}


export function privilegeDelete(parameter) {
  return axios({
    url: api.privilegeDelete,
    method: 'get',
    params: parameter
  })
}
export function privilegeSave(parameter) {
  return axios({
    url: api.privilegeSave,
    method: 'post',
    data: parameter
  })
}
export function privilegeUpdate(parameter) {
  return axios({
    url: api.privilegeUpdate,
    method: 'post',
    data: parameter
  })
}
export function privilegeTree(parameter) {
  return axios({
    url: api.privilegeTree,
    method: 'get',
    params: parameter
  })
}
export function privilegeFindPrivilegeByRole(parameter) {
  return axios({
    url: api.privilegefindPrivilegeByRole,
    method: 'get',
    params: parameter
  })
}

export function rolePage(parameter) {
  return axios({
    url: api.rolePage,
    method: 'get',
    params: parameter
  })
}

export function roleList(parameter) {
  return axios({
    url: api.roleList,
    method: 'get',
    params: parameter
  })
}
export function roleDelete(parameter) {
  return axios({
    url: api.roleDelete,
    method: 'get',
    params: parameter
  })
}
export function roleSave(parameter) {
  return axios({
    url: api.roleSave,
    method: 'post',
    data: parameter
  })
}
export function roleUpdate(parameter) {
  return axios({
    url: api.roleUpdate,
    method: 'post',
    data: parameter
  })
}
export function roleSetProvollege(parameter) {
  return axios({
    url: api.roleSetProvollege,
    method: 'get',
    params: parameter
  })
}

export function userList(parameter) {
  return axios({
    url: api.userList,
    method: 'get',
    data: parameter
  })
}
export function getUserCheckUserNameIsExist(parameter) {
  return axios({
    url: api.userCheckUserNameIsExist,
    method: 'get',
    params: parameter
  })
}
export function userInfo(parameter) {
  return axios({
    url: api.userInfo,
    method: 'get',
    params: parameter
  })
}
export function getUserDelete(parameter) {
  return axios({
    url: api.userDelete,
    method: 'post',
    data: parameter
  })
}
export function getUserPage(parameter) {
  return axios({
    url: api.userPage,
    method: 'post',
    data: parameter
  })
}

export function userResetPassWord(parameter) {
  return axios({
    url: api.userResetPassWord,
    method: 'post',
    params: parameter
  })
}

export function userModifyPassword(parameter) {
  return axios({
    url: api.userModifyPassword,
    method: 'post',
    params: parameter
  })
}

export function userSave(parameter) {
  return axios({
    url: api.userSave,
    method: 'post',
    data: parameter
  })
}

export function userOnlinePage(parameter) {
  return axios({
    url: api.userOnlinePage,
    method: 'get',
    params: parameter
  })
}

export function userOnlineList(parameter) {
  return axios({
    url: api.userOnlineList,
    method: 'get',
    params: parameter
  })
}
export function userOnlineDelete(parameter) {
  return axios({
    url: api.userOnlineDelete,
    method: 'get',
    params: parameter
  })
}
export function userOnlineSave(parameter) {
  return axios({
    url: api.userOnlineSave,
    method: 'post',
    data: parameter
  })
}
export function userOnlineUpdate(parameter) {
  return axios({
    url: api.userOnlineUpdate,
    method: 'post',
    data: parameter
  })
}

export function userOnlineOffLine(parameter) {
  return axios({
    url: api.userOnlineOffLine,
    method: 'post',
    data: parameter
  })
}

export function columnsList(parameter) {
  return axios({
    url: api.columnsList,
    method: 'get',
    params: parameter
  })
}

// 终端管理
export function terminalPage(parameter) {
  return axios({
    url: api.terminalPage,
    method: 'get',
    params: parameter
  })
}
export function terminalDelete(parameter) {
  return axios({
    url: api.terminalDelete,
    method: 'get',
    params: parameter
  })
}
export function terminalSave(parameter) {
  return axios({
    url: api.terminalSave,
    method: 'post',
    data: parameter
  })
}
export function terminalUpdate(parameter) {
  return axios({
    url: api.terminalUpdate,
    method: 'post',
    data: parameter
  })
}
export function terminalAccredit(parameter) {
  return axios({
    url: api.terminalAccredit,
    method: 'post',
    data: parameter
  })
}

export function wxButtonList(parameter) {
  return axios({
    url: api.wxButtonList,
    method: 'get',
    data: parameter
  })
}

export function findWeiXinPrivilegeByRole(parameter) {
  return axios({
    url: api.findWeiXinPrivilegeByRole,
    method: 'get',
    params: parameter
  })
}


export function wxButtonTree(parameter) {
  return axios({
    url: api.wxButtonTree,
    method: 'get',
    params: parameter
  })
}

export function roleSetWxButton(parameter) {
  return axios({
    url: api.roleSetWxButton,
    method: 'get',
    params: parameter
  })
}



// 按钮管理
export function buttonPage(parameter) {
  return axios({
    url: api.buttonPage,
    method: 'get',
    params: parameter
  })
}
export function buttonDelete(parameter) {
  return axios({
    url: api.buttonDelete,
    method: 'get',
    params: parameter
  })
}
export function buttonSave(parameter) {
  return axios({
    url: api.buttonSave,
    method: 'post',
    data: parameter
  })
}
export function buttonUpdate(parameter) {
  return axios({
    url: api.buttonUpdate,
    method: 'post',
    data: parameter
  })
}


export function userExport(parameter) {
  return axios({
    url: api.userExport,
    method: 'post',
    data: parameter
  })
}

// 系统设置
export function settingsList(parameter) {
  return axios({
    url: api.settingsList,
    method: 'get',
    params: parameter
  })
}
export function settingsDelete(parameter) {
  return axios({
    url: api.settingsDelete,
    method: 'get',
    params: parameter
  })
}
export function settingsSave(parameter) {
  return axios({
    url: api.settingsSave,
    method: 'post',
    data: parameter
  })
}
export function settingsUpdate(parameter) {
  return axios({
    url: api.settingsUpdate,
    method: 'post',
    data: parameter
  })
}
export function settingUpdateBatch(parameter) {
  return axios({
    url: api.settingUpdateBatch,
    method: 'post',
    data: parameter
  })
}

export function findproperties(parameter) {
  return axios({
    url: api.findproperties,
    method: 'get',
    params: parameter
  })
}

export function getwxcode(parameter) {
  return axios({
    url: api.getwxcode,
    method: 'get',
    params: parameter
  })
}

export function getopenid(parameter) {
  return axios({
    url: api.getopenid,
    method: 'get',
    params: parameter
  })
}
